export default __webpack_public_path__ + "static/media/home-main.02cefc7b.svg";